// sort the attributes by key so the important ones are at the top
// namely id, name, email, phone, followed by the rest as is
// return the sorted keys
export function sortAttributeKeys(attributes: Record<string, any>[]): string[] {
  const PRIORITY_KEYS = ['id', 'name', 'email', 'phone'];

  if (attributes.length === 0) {
    return [];
  }

  const priority = (key: string) => {
    const idx = PRIORITY_KEYS.indexOf(key);

    // non-important keys should be at the end, so we return Infinity
    return idx === -1 ? Infinity : idx;
  };

  return Object.keys(attributes[0]).sort((a, b) => priority(a) - priority(b));
}
